import EditProfileForm from "../../../components/monaliza/profile/forms/EditProfileForm"




const EditProfile = () => {



    return (
    <>
        <EditProfileForm/>
    </>
  )
}

export default EditProfile